import FilesSection from "./FilesSection.component";

export default FilesSection;
